<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/takE7C/tc-custom/9781467462051.jpg?1742010564480" alt="This image is the cover for the book Proverbs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Proverbs
      </h1>
      <p class="bookDescription body article font2">
        <p><i>An abridged and revised version of Bruce Waltke’s magisterial two-volume NICOT commentary on the book of Proverbs</i> </p><p>Since 2004, Bruce Waltke’s magisterial two-volume NICOT commentary on the book of Proverbs has been recognized as a definitive exegesis of the Hebrew text, groundbreaking in its illuminating analysis that the authors and redactors of Proverbs had organized their material into discernible clusters and groupings. Waltke and Ivan De Silva here offer an abridged and revised version of the preeminent commentary, which is more accessible to students, pastors, and Bible readers in general. In place of a technical analysis of the Hebrew text, Waltke and De Silva interpret the translated text, while also including their own theological reflections and personal anecdotes where appropriate. A topical index is added to help expositors with a book that is difficult to preach or teach verse by verse. </p><p>At its heart, this shorter commentary on Proverbs preserves the exegetical depth, erudition, and poetic insight of Waltke’s original and maintains the core conviction that the ancient wisdom of Proverbs holds profound, ongoing relevance for Christian faith and life today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce K. Waltke, Ivan D. V. De Silva
      </h2>
      
      <p class="authorDescription body article"><B>Bruce K. Waltke</B>&#160;is professor emeritus of biblical studies at Regent College, Vancouver, and distinguished professor emeritus of Old Testament at Knox Theological Seminary, Fort Lauderdale. He was a translator of the New American Standard Version of the Bible and is also a member of the committee responsible for the New International Version.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55adef7e